/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterStoneCut_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly localizedFilterName: string | null;
        readonly canBeDismissed: boolean | null;
        readonly clearAllLinkReference: string | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
            readonly linkReference: string | null;
            readonly count: number | null;
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuStoneCutSelect_itemSearch">;
    readonly " $refType": "SbRespRefineMenuFilterStoneCut_itemSearch";
};
export type SbRespRefineMenuFilterStoneCut_itemSearch$data = SbRespRefineMenuFilterStoneCut_itemSearch;
export type SbRespRefineMenuFilterStoneCut_itemSearch$key = {
    readonly " $data"?: SbRespRefineMenuFilterStoneCut_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterStoneCut_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterStoneCut_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "localizedFilterName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "canBeDismissed",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "clearAllLinkReference",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "linkReference",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "count",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayName",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuStoneCutSelect_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '51f0e0bfae0228714b0344cfad8d2709';
export default node;
